import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import {
  closeNotificationAction,
  openNotificationAction,
  OpenNotificationAction,
} from "redux/notification/notificationActions";

function useNotification() {
  const dispatch = useDispatch();
  return {
    openNotification({ message, type }: OpenNotificationAction["payload"]) {
      return toast(message, {
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: type,
        onOpen: () => dispatch(openNotificationAction(message, type)),
        onClose: () => {
          toast.dismiss();
          dispatch(closeNotificationAction());
        },
      });
    },
    closeNotification() {
      toast.dismiss();
      dispatch(closeNotificationAction());
    },
  };
}

export default useNotification;
